<template>
  <header :class="{ 'content-open': contentOpen, 'touch-pad': touchPad, 'nav-open': navOpen, 'no-title': contentTitle === '' }">
    <div class="container">
      <nav>
        <ul ref="ul">
          <li ref="li1">
            <router-link to="/" class="logo" draggable="false" ondragstart="return false;">
              <img src="../assets/logo-white.svg" alt="">
            </router-link>
          </li>
          <li ref="li2">
            <router-link to="/profil/" draggable="false" ondragstart="return false;">Wer wir sind</router-link>
          </li>
          <li ref="li3">
            <router-link to="/chronik/" draggable="false" ondragstart="return false;">Geschäftsjahr 2020</router-link>
          </li>
          <li ref="li4">
            <router-link to="/werte/" draggable="false" ondragstart="return false;">Werte leben</router-link>
          </li>
          <li ref="li5">
            <router-link to="/finanzbericht/" draggable="false" ondragstart="return false;">Finanzbericht</router-link>
          </li>
        </ul>
        <span class="progress" :style="{ opacity: progressOpacity }" >
          <span class="inner" :style="{ width: progressWidth + '%' }"/>
          <span class="mobile" :style="{ width: (mobileScroll * 100) + '%' }"></span>
        </span>
      </nav>
      <div class="content-nav">
        <button class="back" @click="closeContent" draggable="false" ondragstart="return false;">Zurück</button>
        <p class="title">{{contentTitle}}</p>
      </div>
    </div>
    <button class="toggle-nav" @click="toggleNav" draggable="false" ondragstart="return false;">
      <span></span>
    </button>
  </header>
</template>

<script>
  export default {
    name: "PageHeader",
    data() {
      return {
        navOpen: false,
        progressWidth: 0,
        li: [],
        routes: ['/', '/profil', '/chronik', '/werte', '/finanzbericht']
      }
    },
    props: {
      current: {
        type: Number,
        default: 0
      },
      progress: {
        type: Number,
        default: 0
      },
      contentOpen: {
        type: Boolean,
        default: false
      },
      contentTitle: {
        type: String,
        default: ''
      },
      touchPad: {
        type: Boolean,
        default: false
      },
      progressOpacity: {
        type: Number,
        default: 1
      },
      mobileScroll: {
        type: Number,
        default: 0
      }
    },
    emits: ['close-content'],
    methods: {
      closeContent() {
        this.$emit('close-content');
      },
      toggleNav() {
        this.navOpen = !this.navOpen;
      },
      getCenter(index) {
        if (index === 0) {
          return 0;
        }
        else if (index > 3) {
          return this.$refs.ul.offsetWidth;
        }
        else {
          return Math.round(this.li[index].offsetLeft + this.li[index].offsetWidth / 2);
        }
      }
    },
    watch: {
      progress() {
        const l = this.getCenter(this.current);
        const r = this.getCenter(this.current + 1);
        const w = this.$refs.ul.offsetWidth;
        const p = (l + (r - l) * this.progress) / w;
        this.progressWidth = Math.round(p * 10000) / 100;
      },
      current() {
        //Todo: set router during scrolling
        //this.$router.push({ path: this.routes[this.current] });
        //console.log(this.current);
      }
    },
    mounted() {
      this.li = [this.$refs.li1, this.$refs.li2, this.$refs.li3, this.$refs.li4, this.$refs.li5]
    }
  }
</script>

<style scoped>
  header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 70px 0 60px;
    z-index: 100;
    pointer-events: none;
  }
  header.touch-pad .progress {
    transition: none;
  }
  .container {
    position: relative;
    overflow: hidden;
    padding-top: 40px;
  }
  .content-open:not(.no-title) ul {
    transform: translate3d(0, -100px, 0);
  }
  .content-open:not(.no-title) .content-nav {
    transform: translate3d(0, 0, 0);
  }
  .content-nav {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 1800px;
    color: white;
    padding: 10px 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    transform: translate3d(0, 100%, 0);
    transition: 0.4s ease;
  }
  @media(min-width: 1920px) {
    .content-nav {
      left: 50%;
      transform: translate3d(-50%, 100%, 0);
    }
    .content-open:not(.no-title) .content-nav {
      transform: translate3d(-50%, 0, 0);
    }
  }
  .back {
    display: inline-block;
    padding: 10px 10px 10px 25px;
    background-color: transparent;
    color: white;
    border: 0;
    background-image: url(../assets/images/chevron.svg);
    background-size: 10px;
    background-repeat: no-repeat;
    background-position: 0 center;
    font-size: 18px;
    font-weight: 500;
    font-family: inherit;
    margin: 0;
    cursor: pointer;
  }
  .title {
    font-size: 36px;
    font-weight: 700;
    margin: 0;
  }
  .back:focus {
    outline: 0;
  }
  nav {
    position: relative;
    padding-bottom: 15px;
    max-width: 1800px;
    margin: 0 auto;
  }
  .progress {
    content: "";
    position: absolute;
    display: block;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
    transition: opacity 0.1s ease;
  }
  .progress .inner, .progress .mobile {
    position: relative;
    display: block;
    height: 100%;
    background-color: #fff;
    transition: 0.1s ease;
    border-radius: 2px;
  }
  .progress.mobile {
    display: none;
  }
  .content-open .progress {
    background-color: rgba(255, 255, 255, 1);
  }
  ul {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0;
    padding: 0;
    list-style: none;
    transition: 0.4s ease;
  }
  .logo {
    position: relative;
    display: block;
    overflow: hidden;
    padding: 0;
  }
  .logo img {
    margin-bottom: -10%;
    max-width: 200px;
    display: block;
  }
  a {
    color: white;
    text-decoration: none;
    display: block;
    padding: 5px;
    font-weight: 500;
    font-size: 20px;
  }
  a, button {
    pointer-events: all;
  }
  .toggle-nav {
    display: none;
  }
  @media(max-width: 1199px), (max-height: 799px) {
    header {
      padding: 20px 30px;
    }
    .container {
      padding-top: 5px;
    }
    .logo {
      top: -3px;
    }
    .logo img {
      max-width: 150px;
    }
    a {
      font-size: 18px;
    }
  }
  @media (max-width: 999px) {
    header {
      padding: 0 34px;
    }
    header:before {
      content: "";
      position: absolute;
      top: 0;
      bottom: -100%;
      left: 0;
      right: 0;
      background: linear-gradient(180deg, rgba(5, 15, 33, 1) -50%, rgba(5, 15, 33, 0) 100%);
      pointer-events: none;
    }
    header:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      backdrop-filter: blur(12px);
      opacity: 0;
      transition: 0.3s ease;
      z-index: -1;
    }
    .container {
      padding-top: 20px;
    }
    nav {
      padding-bottom: 5px;
    }
    ul {
      margin: 0;
      overflow: hidden;
      display: block;
      padding: 3px 1px 0;
      max-height: 60px;
      transition: 0.3s ease;
    }
    .nav-open ul {
      max-height: 260px;
      padding-bottom: 25px;
    }
    .nav-open:after {
      opacity: 1;
    }
    li {
      display: block;
      font-size: 0;
      line-height: 0;
    }
    .logo {
      position: relative;
      display: inline-block;
      margin-bottom: 15px;
    }
    .logo img {
      min-width: 180px;
      max-width: 180px;
    }
    .progress, nav:after {
      height: 2px;
      bottom: 0;
    }
    .progress .mobile {
      position: absolute;
      top: 0;
      display: block;
    }
    a:not(.logo) {
      font-size: 20px;
      line-height: 1.5;
      padding: 5px;
      margin-left: -5px;
    }
    .toggle-nav {
      position: absolute;
      display: block;
      right: 28px;
      top: 18px;
      width: 50px;
      height: 50px;
      background-color: transparent;
      padding: 0;
      border: 0;
      transition: 0.3s ease;
    }
    .toggle-nav:focus {
      outline: 0;
    }
    .toggle-nav:before, .toggle-nav:after, .toggle-nav span {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      width: 28px;
      height: 2px;
      margin: -1px -14px;
      background-color: #fff;
      border-radius: 2px;
      transition: margin 0.2s ease 0.2s, transform 0.2s ease, opacity 0s ease 0.2s, color 0.4s ease;
    }
    .toggle-nav:before {
      margin-top: -10px;
    }
    .toggle-nav:after {
      margin-top: 8px;
    }
    .nav-open .toggle-nav:before, .nav-open .toggle-nav:after, .nav-open .toggle-nav:before {
      margin-top: -1px;
      transition: margin 0.3s cubic-bezier(0.225, -0.600, 0.815, -0.600), transform 0.3s ease 0.3s, opacity 0s ease 0.3s;
    }
    .nav-open .toggle-nav:before {
      transform: translate3d(0, 0, 0) rotate(-45deg);
    }
    .nav-open .toggle-nav:after {
      transform: translate3d(0, 0, 0) rotate(45deg);
    }
    .nav-open .toggle-nav span {
      opacity: 0;
    }
    .content-open:before {
      opacity: 0.1;
    }
    .content-open .toggle-nav {
      top: -70px;
    }
    .title {
      font-size: 32px;
      padding-bottom: 2px;
    }
  }
  @media(max-width: 767px) {
    .container {
      padding-top: 0;
    }
    .logo img {
      min-width: 140px;
      max-width: 140px;
      margin: 0 0 -12px;
    }
    header {
      padding: 0 19px;
    }
    ul {
      padding-top: 20px;
    }
    .toggle-nav {
      right: 8px;
      top: 10px;
    }
    .title {
      font-size: 22px;
      padding-bottom: 6px;
      margin-left: -5px;
    }
  }
  @media(max-width: 567px) {
    .content-nav {
      justify-content: flex-start;
    }
    .back {
      font-size: 0;
      padding: 0;
      width: 40px;
      height: 40px;
    }
    .title {
      padding-bottom: 3px;
    }
  }
</style>